// Libs
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import {
  Actionbar,
  Flexbox,
  ToolButton,
  SingleSelect,
  ButtonGroup
} from '@ibinder/common-frontend';

// Icons
import { tableList, cardList, plus, edit } from '@ibinder/common-icons';

// Styles
const StyledActionbar = styled.div`
  margin: 0 -1rem;

  > *:first-child {
    > * {
      margin: 1rem;

      &:first-child {
        margin-right: auto;
        margin-top: auto;
      }
    }
  }
`;

const ActionbarContent = styled(Flexbox)`
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid ${(p) => p.theme.colors.discrete60};
`;

const ExtraSpace = styled.span`
  margin-right: 0.75rem;
  @media (max-width: ${(p) => p.theme.devices.xs}px) {
    display: none;
  }
`;

const ItemNo = styled.p``;

const Bold = styled.span`
  font-weight: bold;
  margin: 0 0.25rem;
`;

// Constants
export const VIEW_LIST_VARIANTS = [
  {
    index: 0,
    name: 'TABLE_LIST',
    icon: tableList
  },
  {
    index: 1,
    name: 'CARD_LIST',
    icon: cardList
  }
];

/* These match pattern expected by SingleSelect */
export const SORTING_VARIANTS = {
  ASC: 'ASC',
  DESC: 'DESC'
};

const InspectionTypeActionbar = ({
  headers,
  queryData,
  selectedIds,
  activeView,
  changeActiveListView,
  changeSorting,
  changeActiveSortField,
  sortingFilter,
  createInspectionTypeTemplate,
  editInspectionTypeTemplate,
  activeIndex
}) => {
  const { t } = useTranslation();

  return (
    <StyledActionbar>
      <ActionbarContent>
        <ItemNo>
          {t('Showing')}
          <Bold>{queryData.length}</Bold>
          {t('types')}
        </ItemNo>
        <ButtonGroup
          label={t('View as list')}
          activeIndex={VIEW_LIST_VARIANTS.findIndex(
            (i) => i.index === activeView.index
          )}
          buttonGroupData={VIEW_LIST_VARIANTS}
          onClickCallback={changeActiveListView}
        />
        <SingleSelect
          loading={false}
          label={t('Sort by')}
          withSortButton={true}
          activeIndex={activeIndex}
          dropdownData={headers.map((item, i) => ({
            Key: i,
            Value: t(item.name)
          }))}
          dropdownText={t('Sort by')}
          onClickSorting={changeSorting}
          onClickSelectItem={changeActiveSortField}
          sorting={sortingFilter}
        />
      </ActionbarContent>
      <ActionbarContent>
        {selectedIds.length === 0 && (
          <ToolButton type="button" onClick={createInspectionTypeTemplate}>
            {plus}
            <ExtraSpace>{t('Add type')}</ExtraSpace>
          </ToolButton>
        )}
        {selectedIds.length === 1 && (
          <ToolButton type="button" onClick={editInspectionTypeTemplate}>
            {edit}
            <ExtraSpace>{t('Edit type')}</ExtraSpace>
          </ToolButton>
        )}
      </ActionbarContent>
    </StyledActionbar>
  );
};

export default InspectionTypeActionbar;
